import { useNavigate } from "@tanstack/react-router";
import { Button } from "../../ui/button";

export default function NotFound() {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate({ to: "/" }); // Navigate to home page using TanStack Router
  };

  return (
    <div className="m-auto flex min-h-60 flex-col items-center justify-center px-4 text-center">
      {/* Image Container with background elements */}
      <img
        src={"/404/not-found.jpg"}
        alt="Something went wrong illustration"
        width={200} // Reduced width
        height={167} // Reduced height (maintaining aspect ratio)
        className="mb-4"
      />

      <h1 className="mb-4 font-bold text-3xl text-gray-800">
        Oops! Something Went Wrong
      </h1>
      <p className="mb-8 max-w-md text-gray-500 text-lg">
        You didn't break the internet, but we can't find what you are looking
        for.
      </p>

      <Button onClick={handleTryAgain} size="lg">
        Go to Home
      </Button>
    </div>
  );
}
